import _ from 'lodash';
import getRedirectDelay from '@/helpers/getRedirectDelay';

export default {
  /** Delay in ms before the redirect to the merchant return url */
  redirectDelay: state => getRedirectDelay(state.checkoutOptions),

  getMethodsByCategoryName: state => categoryName => {
    return state.groupedCategories && categoryName in state.groupedCategories
      ? state.groupedCategories[categoryName]
      : [];
  },

  currentTheme: state => state.currentTheme,
  methodsArray: state => {
    const methods = state.methods;
    if (methods) {
      return Object.keys(methods).map(method => {
        return methods[method];
      });
    }
    return [];
  },

  /** Methods with additional and agttegated data, tooltips, auto process, geo etc */
  extendedMethods: state => {
    const methods = state.methods || {};
    const services = state.services || {};

    const data = [];

    for (const index in methods) {
      if (Object.prototype.hasOwnProperty.call(methods, index)) {
        const methodData = methods[index],
          methodServices = services[index],
          method = {};

        if (methodServices && methodServices.length && methodServices.length == 1) {
          if (
            methodServices[0].flow === 'hpp' &&
            methodServices[0].fields &&
            methodServices[0].fields.length === 0
          ) {
            method.tooltip = true;
            method.tooltipData = {
              title: 'direct_call_forwarding',
              description: 'direct_call_forwarding_description',
            };

            method.autoProcess = true;
          }
        }

        let symbol = methodData.icon.indexOf('?') !== -1 ? '&' : '?';

        method.logo = `${methodData.icon}${symbol}w=130`;
        method.code = methodData.code;

        data.push(method);
      }
    }

    return data;
  },

  isInDisabledMethods: state => methodCode => {
    return state.disabled_methods.indexOf(methodCode) != -1;
  },

  isInDisabledServices: state => serviceCode => {
    return state.disabled_services.indexOf(serviceCode) != -1;
  },
};
